export const SINGLE_PEN_STYLES = {
  rct_needed: {
    penId: "rct_needed",
    label: "RCT Needed",
    fillColor: "#FF8C42",
    borderColor: "#C25E1F",
    renderStyle: "badge",
    overlaySymbol: "rctText",
    toothOutline: "none",
    cornerPosition: "topRight",
  },
  missing: {
    penId: "missing",
    label: "Missing",
    fillColor: "#9CA3AF",
    borderColor: "#4B5563",
    renderStyle: "fullTooth",
    overlaySymbol: "x",
    toothOutline: "solid",
    exclusiveWith: ["to_extract", "watch"],
  },
  to_extract: {
    penId: "to_extract",
    label: "To Extract",
    fillColor: "#EF4444",
    borderColor: "#991B1B",
    renderStyle: "tint",
    overlaySymbol: null,
    toothOutline: "dashed",
    exclusiveWith: ["missing", "watch"],
  },
  sensitivity: {
    penId: "sensitivity",
    label: "Sensitivity",
    fillColor: "#FEF3C7",
    borderColor: "#D97706",
    renderStyle: "outlineRing",
    overlaySymbol: "lightningRing",
    toothOutline: "none",
  },
  discoloration: {
    penId: "discoloration",
    label: "Discoloration",
    fillColor: "#D6BFAB",
    borderColor: "#78544A",
    renderStyle: "tint",
    overlaySymbol: null,
    toothOutline: "none",
  },
  watch: {
    penId: "watch",
    label: "Watch",
    fillColor: "#E0E7EF",
    borderColor: "#64748B",
    textColor: "#475569",
    renderStyle: "pillBadge",
    overlaySymbol: null,
    toothOutline: "none",
    pillText: "Watch",
    cornerPosition: "dynamic",
    exclusiveWith: ["missing", "to_extract"],
  },
};

export const SINGLE_PEN_IDS = Object.keys(SINGLE_PEN_STYLES);

export function isSinglePenCode(code) {
  return !!SINGLE_PEN_STYLES[code];
}

export function getSinglePenStyle(code) {
  return SINGLE_PEN_STYLES[code] || null;
}

export function getSinglePenExclusiveCodes(code) {
  return SINGLE_PEN_STYLES[code]?.exclusiveWith || [];
}

export function getPillPosition(toothMarkers = []) {
  const corners = ["topRight", "topLeft", "bottomRight", "bottomLeft"];
  const occupied = toothMarkers
    .filter((marker) => marker.cornerPosition)
    .map((marker) => marker.cornerPosition);
  const available = corners.find((corner) => !occupied.includes(corner));
  if (available) return available;
  console.warn("All tooth marker corners are occupied; falling back to top-left.");
  return "topLeft";
}
